import { AUTH_ROUTE_TARGETS } from 'src/app/auth/@shared/auth-route-targets';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { Capacitor, PluginListenerHandle } from '@capacitor/core';
import { Injectable, NgZone, inject } from '@angular/core';
import { NavController } from '@ionic/angular';
import { unbindPluginListeners } from 'src/app/@shared/app-helper';

@Injectable({
  providedIn: 'root',
})
export class DeeplinkService {
  private pluginListeners: { [key: string]: PluginListenerHandle } = {};

  private navController = inject(NavController);
  private zone = inject(NgZone);

  public async init(): Promise<void> {
    if (Capacitor.isNativePlatform()) {
      // TODO: do something if url is not root url

      try {
        const { url } = await App.getLaunchUrl();

        console.info(`App opened with URL: ${url}`);
      } catch (error) {
        console.error(error.message);
      }
    }

    return this.bindPluginListeners();
  }

  public ngOnDestroy(): void {
    unbindPluginListeners(this.pluginListeners);
  }

  private handleDeeplink(data: URLOpenListenerEvent): void {
    this.zone.run(() => {
      // TODO: implement deeplink handling
      console.info('Handle deeplink', data);

      if (!data || !data.url) {
        return;
      }

      // if (typeof data === 'string') { return; }

      if (data.url.includes('/password-reset')) {
        const parts = data.url.split('/');
        const token = parts[parts.length - 1];

        this.navController.navigateRoot(AUTH_ROUTE_TARGETS.passwordResetRedirect(token)).catch();
      }
    });
  }

  private async bindPluginListeners(): Promise<void> {
    this.pluginListeners.appUrlOpen = await App.addListener('appUrlOpen', (data) => {
      this.handleDeeplink(data);
    });

    return Promise.resolve();
  }
}
